// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

export const equals = x => value => value === x;

export const notEquals = x => value => value !== x;

export const greaterThan = x => value => value > x;

export const lessThan = x => value => value < x;

export const isInRange = (min, max) => value => {
	return value > min && value < max;
};

export const isBetweenInclusive = (min, max) => value => {
	return value >= min && value <= max;
};